export default __webpack_public_path__ + "static/media/1885.8db211de.png";